// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "aebd121926d3d758","396": "2298b60fcc08cf56","460": "e3d67237a490cf08","917": "ed9c2906c642f5f1","985": "22440d725e23c555",}[chunkId] + ".chunk.js"
}